import {createSlice, PayloadAction} from "@reduxjs/toolkit";

interface HeaderSlice {
    title:string;
}
const initialState:HeaderSlice = {
    title: "DASHBOARD"
}
export const headerSlice = createSlice({
    name: "header",
    initialState,
    reducers: {
        setTitle: (state, action: PayloadAction<string>) => {
            state.title = action.payload;
        }
    }
});

export const {
    setTitle
} = headerSlice.actions;

export default headerSlice.reducer;